module.exports = __webpack_public_path__ + "img/65A0C7_C3E4F8_A7D5EF_97CAE9-256px.c114c0ab.png";